export default class AroundSection {
  constructor() {
    const around = document.getElementById("around");
    const aroundWrap = document.getElementsByClassName("c-around");
    // MAPから各地域の取得
    const map = document.getElementById("map");
    const mapTarget = map.querySelectorAll(`[id^='mapTarget']`);
    const area = map.querySelectorAll(".area");
    const mapTargetArray = Array.from(mapTarget);
    // swiperから各地域の取得
    const swiperWrap = document.getElementById("swiperWrap");
    const slideTarget = [].slice.call(
      swiperWrap.getElementsByClassName("swiper-slide")
    );

    // for (let i = 0; i < mapTargetArray.length; i++) {
    //   // マップをクリックしたときの動作
    //   const svgTarget = mapTargetArray[i].querySelector("g");
    //   svgTarget.addEventListener("click", () => {
    //     // mapTargetArray[i].addEventListener('click', () => {
    //     const currentName = mapTargetArray[i].className;
    //     setCurrentName(currentName, i);
    //   });
    // }
    for (let i = 0; i < area.length; i++) {
      // マップをクリックしたときの動作
      const areaTarget = area[i];
      areaTarget.addEventListener("click", () => {
        const currentName = areaTarget.className.split("area-")[1];
        setCurrentName(currentName, i);
      });
    }
    function setCurrentName(currentName, i) {
      around.className = "around" + " " + currentName;
      // console.log(currentName, i);
      aroundSwiper.slideTo(i, 1000, function () {});
    }

    // コンテンツ幅〜769の間、地図・スライダーをコンテンツ幅に対する割合で縮小してリキッド対応
    function resizing() {
      if (window.matchMedia("(min-width: 769px)").matches) {
        // console.log(">769");
        around.style.transform = `translateX(-50%) scale(${Math.min(
          window.innerWidth / 1300,
          1
        )})`;
        around.style.height = `${
          650 * Math.min(window.innerWidth / 1300, 1)
        }px`;
        /* ビューポートの幅が 769 ピクセル以上の場合のコードをここに */
      } else {
        // console.log("<769");
        around.style.transform = `translateX(-50%) scale(${1})`;
        around.style.height = `650px`;
        /* ビューポートの幅は 769 ピクセル未満の場合のコードをここに */
      }
    }
    window.addEventListener("resize", resizing);
    resizing();
  }
}
